var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmaterialEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.012,
    height: 19.012,
    viewBox: "0 0 19.012 19.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,19.548v3.96H8.46l11.68-11.68-3.96-3.96ZM23.2,8.765a1.052,1.052,0,0,0,0-1.489L20.732,4.805a1.052,1.052,0,0,0-1.489,0L17.31,6.738l3.96,3.96L23.2,8.765Z",
    transform: "translate(-4.5 -4.496)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialEdit);
export default __webpack_public_path__ + "static/media/Icon material-edit.715b59f40be383aa705b007ef71e0856.svg";
export { ForwardRef as ReactComponent };